import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ChatbotWidget from "../components/chatbot/ChatbotWidget"; // adjust path to yours

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ClinicChatPage() {
  const { clinicKey } = useParams();
  const [clinicId, setClinicId] = useState(null);
  const [clinicName, setClinicName] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setError(null);
        setClinicId(null);

        const res = await fetch(
          `${API_BASE}/resolve-clinic?key=${encodeURIComponent(clinicKey)}`
        );

        if (!res.ok) {
          const msg = await res.text();
          throw new Error(msg || "Failed to resolve clinic");
        }

        const d = await res.json();
        if (cancelled) return;

        setClinicId(d.clinic_id);
        setClinicName(d.clinic_name || null);
      } catch (e) {
        if (!cancelled) setError(e.message || "Failed to load clinic");
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [clinicKey]);

// ✅ ADD DEBUG LOG HERE
console.log("clinicKey:", clinicKey, "resolved clinicId:", clinicId);

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <h3>Chat unavailable</h3>
        <p>{error}</p>
      </div>
    );
  }

  if (!clinicId) {
    return (
      <div style={{ padding: 24 }}>
        Loading chat...
      </div>
    );
  }



  return (
    <div style={{ height: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {/* Optional: pass clinicName if you want to show it in header */}
      

      <ChatbotWidget clinicId={clinicId} clinicName={clinicName} />
    </div>
  );
}



